import { defineMessages } from 'react-intl';

const messages: {
	goodResponseLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	badResponseLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	goodResponseLabel: {
		id: 'chatHistory.storeAssistant.goodResponseLabel',
		defaultMessage: 'Good response',
		description: 'Label for the good response button',
	},
	badResponseLabel: {
		id: 'chatHistory.storeAssistant.badResponseLabel',
		defaultMessage: 'Bad response',
		description: 'Label for the bad response button',
	},
});

export default messages;
